import {
  bl_alg_cc_qc_monthly_hdr_RowClass,
  bl_alg_cc_qc_monthly_hdr_RowInterface,
} from "../../../../dbschema/bl_alg_cc_qc_monthly_hdr.model";
import { bl_alg_cc_qc_monthly_line_RowClass } from "../../../../dbschema/bl_alg_cc_qc_monthly_line.model";
import { BaseContainerModel } from "../../../base-container.model";

//this is for answer of qc_hdr
export class QualityControlMonthlyContainerModel extends BaseContainerModel {
  bl_alg_cc_qc_monthly_hdr: bl_alg_cc_qc_monthly_hdr_RowInterface =
    new bl_alg_cc_qc_monthly_hdr_RowClass();
  bl_alg_cc_qc_monthly_line: bl_alg_cc_qc_monthly_line_RowClass[] = [];
}
